import { MediaParticipant } from "@dvrt/web-phone-client";
import { useParticipantStatus } from "../../../participantStatus";
import { useParticipantDisplayName } from "../../../hooks";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, useTheme } from "@mui/material";
import { FormattedMessage } from "react-intl";

const Caption = ({ participant }: { participant: MediaParticipant }) => {
    const { isMuted, handRaised, isHost } = useParticipantStatus(participant.cname);
    const displayName = useParticipantDisplayName(participant);
    const theme = useTheme();

    return (
        <Box
            sx={{
                position: "absolute",
                bottom: 5,
                left: 5,
                backgroundColor: "rgba(10, 10, 10, 0.4)",
                padding: "3px 7px",
                borderRadius: theme.shape.borderRadius,
                backdropFilter: "blur(4px)",
                maxWidth: "calc(100% - 10px)",
                display: "flex",
                alignItems: "center",
            }}
        >
            <FontAwesomeIcon icon={isMuted ? "microphone-slash" : "microphone"} style={{ marginRight: "0.5em" }} />
            <Box
                component="span"
                sx={{
                    fontWeight: "bold",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                }}
            >
                {displayName}
            </Box>
            {isHost && (
                <Box
                    component="span"
                    style={{
                        opacity: 0.8,
                        fontSize: "0.8em",
                        marginLeft: "0.4em",
                    }}
                >
                    (<FormattedMessage id="meetingPage.room.grid.host" defaultMessage="host" />)
                </Box>
            )}
            {participant.screen ? (
                <FontAwesomeIcon icon="desktop" style={{ marginLeft: "0.4em" }} />
            ) : (
                <Box
                    component="span"
                    sx={[
                        {
                            marginLeft: "0.4em",
                            transition: "opacity 0.2s",
                        },
                        handRaised
                            ? {
                                  opacity: 1,
                              }
                            : {
                                  opacity: 0.1,
                              },
                    ]}
                >
                    <FontAwesomeIcon icon="hand-paper" />
                </Box>
            )}
        </Box>
    );
};
export default Caption;
